const ActionMode = {
  IN: 'in',
  OUT: 'out',
  NONE: 'none'
};

export { ActionMode };
